// Note: To trace state transitions, inject $trace, and call $trace.enable(1).
(function () {
  angular.module('app').run(runApp);

  /* @ngInject */
  function runApp(
    apiInterceptorReady,
    authenticationReady,
    featureReady,
    invitesReady,
    localeReady,
    mainBoot
  ) {
    mainBoot.makeReady(
      apiInterceptorReady,
      authenticationReady,
      featureReady,
      invitesReady,
      localeReady
    );
  }
})();
